import React from 'react'
import EmbededEntityInput from '../../input/embedded_entity'
import OptionsField from 'react-mobx-admin/components/common/field/opts'
import SelectInput from '../../input/select'
import TextField from 'react-mobx-admin/components/common/field/text'
import TextInput from 'bstrap-react-mobx-admin/input/text'

const SharesEdit = ({ store, ...rest }) => {
  //
  const _ShareEditForm = ({ store, record, updateFormField, errors }) => {
    record.get('share') && record.set('share', parseFloat(record.get('share')).toFixed(2))

    return (
      <div className='row'>
        <div className='col-xs-12'>
          <SelectInput label={store.__('contractor')} attr={'contractor_id'} record={record}
            onChange={updateFormField} labelattr='name' valueattr='id'
            optionsrecord={store.options} optionsattr={'clients'} errors={errors} />
          <TextInput type='number' step='0.1' label={store.__('share (%)')} attr={'share'}
            record={record} onChange={updateFormField} errors={errors} />
          <SelectInput label={store.__('platform')} attr={'platform'} record={record}
            onChange={updateFormField} optionsrecord={store.options}
            optionsattr={'Platforms'} labelattr='text' errors={errors} />
          <SelectInput label={store.__('right type')} attr={'right_type'} record={record}
            onChange={updateFormField} labelattr='text' valueattr='value'
            optionsrecord={store.options} optionsattr={'RightsTypes'} errors={errors} />
          <SelectInput label={store.__('limited to source of revenues')} attr='source_of_revenues_cd' record={record}
            onChange={updateFormField} labelattr='text' valueattr='value'
            valueFilterFc={i => !i.text.includes('video')}
            optionsrecord={store.options} optionsattr='UploadTypes' errors={errors} />
        </div>
      </div>
    )
  }

  return (
    <EmbededEntityInput {...rest}
      store={store}
      edit_title={store.__('edit shares')}
      add_title={store.__('add shares')}
      attr={'shares'}
      errors={store.cv.errors}
      fields={[
        (attr, row) => {
          const DetailLink = ({ text }) => (
            <a href='javascript:void(0)'
              onClick={() => store.goTo('entity_detail', { entityname: 'clients', id: row[attr] })}>
              <span className='glyphicon glyphicon-share-alt' />&nbsp;{text}
            </a>
          )

          return <OptionsField
            attr={attr}
            val={row[attr]}
            options={store.options.get('clients')}
            labelattr='name' valueattr='id'
            Component={DetailLink} />
        },
        (attr, row) => (<TextField attr={attr} val={row[attr]} toFixed={2} />),
        (attr, row) => (
          <OptionsField attr={attr} val={row[attr]}
            options={store.options.get('Platforms')}
            labelattr='text' />
        ),
        (attr, row) => (
          <OptionsField attr={attr} val={row[attr]}
            options={store.options.get('RightsTypes')}
            labelattr='text'
            valueattr='value' />
        ),
        (attr, row) => (
          <OptionsField attr={attr} val={row[attr]}
            options={store.options.get('UploadTypes')}
            labelattr='text'
            valueattr='value' />
        )
      ]}
      rowId={(row) => (row)}
      EditForm={_ShareEditForm}
    />
  )
}
export default SharesEdit
